export default __webpack_public_path__ + "0db630f0f1c478d08e5eaf096a19e766.png";